import get from 'lodash/get';
import head from 'lodash/head';
import isEmpty from 'lodash/isEmpty';
import { FacetFields, SearchCategoryTypes } from '@yme/utils/bloomreach';
import { ACCESSORY_FACETS, APPAREL_FACETS } from '@yme/utils/bloomreach/constants';
export function mergeTabsData(tabsData, primaryFacets, categoryTypeLabel) {
    return tabsData
        .map((tab) => {
        const primaryFacet = primaryFacets.find((facet) => facet.name?.toLowerCase() === tab.type);
        const title = get(categoryTypeLabel, tab.type, tab.type);
        const amount = primaryFacet?.count ?? '';
        return {
            ...tab,
            tabTitle: title,
            defaultTabTitle: title,
            amountLabel: String(amount),
        };
    })
        .filter((tab) => tab?.amountLabel !== '');
}
export const getFacetProperty = (facetValue) => {
    if (!facetValue) {
        return '';
    }
    const types = facetValue.split(',');
    if (types.length > 1) {
        return `("${types.join('" OR "')}")`;
    }
    return `"${head(types)}"`;
};
export const getFacetProperties = (primaryType, facets) => {
    const primaryTypeQuery = `primary_type: "${primaryType}"`;
    if (Object.values(facets).every(isEmpty)) {
        return primaryTypeQuery;
    }
    const facetProperties = Object.entries(facets);
    const facetQueries = facetProperties
        .map(([facetName, facetValue]) => {
        if (isEmpty(facetValue)) {
            return '';
        }
        return `${facetName}: ${getFacetProperty(facetValue)}`;
    })
        .filter(Boolean);
    return `${primaryTypeQuery},${facetQueries.join(',')}`;
};
export const getUnitFacets = (facets) => {
    return facets.filter((facet) => facet.name === FacetFields.UNIT_TYPE);
};
export function getAccessoryFacets(facets) {
    return facets.filter((facet) => ACCESSORY_FACETS.includes(facet.name) && facet.value.length > 0);
}
export function getApparelFacets(facets) {
    return facets.filter((facet) => APPAREL_FACETS.includes(facet.name) && facet.value.length > 0);
}
export function getCurrentCategoryFacets(facets, categoryType) {
    switch (categoryType) {
        case SearchCategoryTypes.UNIT:
            return getUnitFacets(facets);
        case SearchCategoryTypes.ACCESSORY:
            return getAccessoryFacets(facets);
        case SearchCategoryTypes.APPAREL:
            return getApparelFacets(facets);
        default:
            return facets;
    }
}
export function mergeFacetsCounts(prevFacets, currentFacets) {
    const result = prevFacets.map((facet) => {
        const currentFacet = currentFacets.find((item) => item.name === facet.name);
        return {
            ...facet,
            value: facet.value.map((facetItem) => {
                const currentValue = currentFacet?.value.find((item) => item.name === facetItem.name);
                return {
                    ...facetItem,
                    count: currentValue?.count ?? 0,
                };
            }),
        };
    });
    return result;
}
export function buildFacets(facets) {
    return facets.map(({ name, value, activeOptions = [] }) => ({
        name,
        values: value.map(({ count, name }) => ({
            name,
            value: name,
            label: name,
            count,
            checked: activeOptions.includes(name),
        })),
    }));
}
export function updateFacets(facets) {
    return facets
        .filter((facet) => {
        if (facet.name === FacetFields.IS_DISCOUNTED) {
            return facet.value.find((item) => Number(item.name) === 1);
        }
        return true;
    })
        .sort((a) => (a.name === FacetFields.IS_DISCOUNTED ? -1 : 1));
}
